
import React from 'react';
import Guidelines from '../components/Guidelines';
import Footer from '../components/Footer';


function Guideline() {
  return (
    <>
        <Guidelines />
        <Footer />
    </>
  );
}


export default Guideline;
